<template>
    <!-- 诗词页头部 -->
    <div class="poem-page-header">
        <!-- 文字 -->
        <div class="sentence" v-if="sentence != null">
            <!-- 内容 -->
            <vue-typer
                    :text="sentence.content"
                    :repeat='0'
                    :shuffle='false'
                    initial-action='typing'
                    :pre-type-delay='70'
                    :type-delay='180'
                    :pre-erase-delay='2000'
                    :erase-delay='250'
                    :erase-on-complete='false'
                    caret-animation='expand'
                    erase-ype = "clear"
                    class="content"
            ></vue-typer>
            <!-- 信息 -->
            <vue-typer
                    :text="'--- '+sentence.poet.name + '《'+sentence.poem.title+'》'"
                    :repeat='0'
                    :shuffle='false'
                    initial-action='typing'
                    :pre-type-delay='2000'
                    :type-delay='70'
                    :pre-erase-delay='4000'
                    :erase-delay='250'
                    :erase-on-complete='false'
                    caret-animation='expand'
                    erase-ype = "clear"
                    class="info"
                    v-show="showPoet"
            ></vue-typer>
        </div>


        <!-- 毛玻璃遮罩层 -->
        <div class="pic-blur"></div>


    </div>
</template>

<script>
    import {GetSentences} from '@/request/poem';
    import { VueTyper } from 'vue-typer';
    export default {
        name: "Header",
        components:{
          VueTyper
        },
        created() {
            // TODO 被创建时，先获取一条名句
            GetSentences({
                num:1
            }).then(res => {
                if (res.code === 200){
                    this.sentence = res.data.list[0];
                }
            })
            // 设置定时器，控制作者那一栏的显示
            setTimeout(() => this.showPoet = true,2000)
        },
        data() {
            return {
                sentence:null,
                showPoet:false
            };
        },
    }
</script>

<style lang="less">
    .poem-page-header{
        width: 100%;
        height: 450px;
        background-image: url("../../../../assets/poem-back.jpg");
        background-size: cover;
        background-position: center center;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        // 遮罩模糊
        .pic-blur{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top:0;
            background: inherit;
            filter: blur(1.8px);
        }

        /* 文字内容 */
        .sentence{
            color: white !important;
            position: relative;
            top:0;
            left: 0;
            z-index: 2;
            /* 正文内容 */
            .content{
                font-size: 38px;
                letter-spacing: 3px;
                font-weight: bold;
                font-family: 宋体;
                margin-bottom: 35px;
                display: block;
                /* 打字机样式 */
                .char{
                    color: white !important;
                }
                .caret{
                    background-color: white !important;
                }
            }
            /* 信息数据 */
            .info{
                display: flex;
                justify-content: flex-end;
                font-size: 21px;
                font-weight: bold;
                font-family: 楷体;
                height: 26px;
                /* 打字机样式 */
                .char{
                    color: white !important;
                }
                .caret{
                    background-color: white !important;
                }
            }
        }


    }
</style>